




















































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import TableList from "@/components/partials/TableList.vue";
import SoldItemCardContent from "@/components/partials/YourStore/SoldItemCardContent.vue";
import { ActivatedItem } from "@/interfaces/entities/ActivatedItem";
import AddCustomerEmailModal from "@/components/partials/AddCustomerEmailModal.vue";
import TDSModal from "@/components/partials/TDSModal/TDSModal.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import ESimDetailsModal from "@/components/partials/ESimDetailsModal.vue";
import CountryPicker from "@/components/partials/CountryPicker.vue";
import {Country} from "@/interfaces/Country";
import {tools} from "@/util/tools";
import {Balance} from "@/interfaces/entities/Balance";
import { Price } from "@/interfaces/entities/Price";
import { ActivatedItemAddon } from "@/interfaces/entities/ActivatedItemAddon";

@Component({
    components: {
        ESimDetailsModal,
        TDSModal,
        SoldItemCardContent,
        TableList,
        DefaultLayout,
        AddCustomerEmailModal,
        TDSButton,
        CountryPicker
    }
})
export default class HistoryDetails extends Vue {
    private isLoading: boolean = false;
    private soldItem: ActivatedItem | null = null;
    private tableColumnsHistory: object = {
        date: { label: this.$t("tableHeader.dateOfSale") as string, width: "150px" },
        name: { label: this.$t("tableHeader.dataPackage") as string },
        volume: { label: this.$t("tableHeader.volume") as string, width: "100px", align: "right" },
        validity: { label: this.$t("tableHeader.validity") as string, width: "100px" },
        addons: { label: this.$t("tableHeader.addonPrice") as string, width: "140px", align: "right" },
        purchasePrice: { label: this.$t("tableHeader.purchasePrice") as string, width: "140px", align: "right" },
        retailPrice: { label: this.$t("tableHeader.retailPrice") as string, width: "140px", align: "right" }
    };
    private tableColumnsActivationAddition: object = {
        activatedAt: { label: this.$t("tableHeader.activatedAt") as string, width: "150px" },
        activationMode: { label: this.$t("tableHeader.activationMode") as string, width: "196px" },
        remaining: { label: this.$t("tableHeader.remaining") as string, width: "100px", align: "right" },
        expiresAt: { label: this.$t("tableHeader.expiresAt") as string, width: "200px" },
        actions: { label: this.$t("tableHeader.actions") as string, align: "right" }
    };
    private tableColumnsExtendedPolicy: object = {
        throttledSpeed: { label: this.$t("tableHeader.throttledSpeed") as string },
        dailyHighSpeed: { label: this.$t("tableHeader.dailyHighSpeed") as string },
        dailyBalance: { label: this.$t("tableHeader.dailyBalance") as string },
        resetsAt: { label: this.$t("tableHeader.resetsAt") as string }
    };
    private tableColumnsHistoryAddition: object = {
        channel: { label: this.$t("tableHeader.channel") as string, width: "150px" },
        activationId: { label: this.$t("tableHeader.activationId") as string, width: "160px"},
        metatag: { label: this.$t("tableHeader.metatag") as string },
        status: { label: this.$t("tableHeader.status") as string, width: "100px", align: "right" },
        actions: { label: this.$t("tableHeader.actions") as string, align: "right" }
    };
    private tableColumnsCustomer: object = {
        customer: { label: this.$t("tableHeader.customerProfile") as string, width: "275px" },
        email: { label: this.$t("tableHeader.email") as string, width: "250px" },
        balance: { label: this.$t("tableHeader.balance") as string, width: "100px" },
        profiles: { label: this.$t("tableHeader.attachedProfiles") as string, width: "150px" },
        country: { label: this.$t("tableHeader.countryOfResidence") as string, width: "175px" }
    };
    private tableColumnsDetails: object = {
        ICCID: { label: "ICCID" },
        status: { label: this.$t("tableHeader.status") as string },
        installationLink: { label: this.$t("tableHeader.installationLink") as string, width: "290px" }
    };
    private copySuccess: boolean = false;
    private showEmailModal: boolean = false;
    private showDetailsModal: boolean = false;
    private eSimUid: string = "";
    private showMetatagModal: boolean = false;
    private metatagIsValidXml: boolean = true;
    private showRefundModal: boolean = false;
    private showCountryModal: boolean = false;
    private showActivateModal: boolean = false;
    private isRefunding: boolean = false;
    private countryValid: boolean = true;
    private selectedCountry: Country | null = null;
    private isSavingCountry: boolean = false;
    private isActivating: boolean = false;

    created() {
        this.fetchSoldItem();
        if (this.$route.query.sortDirHistory && this.$route.query.sortKeyHistory) {
            this.$store.commit("SET_PREVIOUS_VIEW", "/your-store/history?sortDir=" + this.$route.query.sortDirHistory + "&sortKey=" + this.$route.query.sortKeyHistory);
        } else {
            this.$store.commit("SET_PREVIOUS_VIEW", "/your-store/history");
        }
    }

    get isMobile(): boolean {
        return this.$store.state.isMobile;
    }

    private reload() {
        this.showEmailModal = false;
        this.fetchSoldItem();
    }

    private async fetchSoldItem() {
        this.isLoading = true;
        try {
            this.soldItem = await this.$store.dispatch("GET_SOLD_ITEM_BY_ID", this.$route.params.id);
            if (this.soldItem?.relatedEsims?.length === 0) {
                this.soldItem.relatedEsims.push({
                    activatedAt: null,
                    activationCode: "---",
                    iccid: "---",
                    imsi: "---",
                    installationUrl: "---",
                    lastSeen: null,
                    state: "---",
                    uid: "---",
                    active: false,
                    appleUniversalLink: "---",
                    androidUniversalLink: "---",
                    customerProfileDomainId: "---"
                });
            }
        } catch (e) {
            console.error("[Your Store Inventory] Failed fetching sold item");
        } finally {
            this.isLoading = false;
            this.metatagIsValidXml = this.isValidXml(this.soldItem ? this.soldItem.activatedItem.metatag : "");
        }
    }

    get metatagIsLong(): boolean {
        if (!this.soldItem) return false;
        if (this.isMobile) return this.soldItem.activatedItem.metatag.length >= 30;
        else return this.soldItem.activatedItem.metatag.length >= 50;
    }

    private isValidXml(metatag: string): boolean {
        const parser = new DOMParser();
        const parsererrorNS = parser.parseFromString("INVALID", "text/xml").getElementsByTagName("parsererror")[0].namespaceURI;
        const document = parser.parseFromString(metatag ? metatag : "", "text/xml");
        return document.getElementsByTagNameNS(parsererrorNS ? parsererrorNS : "http://www.w3.org/1999/xhtml", "parsererror").length <= 0;
    }

    private async copyToClipBoard(text: string) {
        if (!text) return;
        await navigator.clipboard.writeText(text);
        this.$toastr.success(this.$t("components.inputfield.copied"), true, true);
    }

    openAddEmailModal() {
        this.showEmailModal = true;
    }

    openAddCountryModal() {
        this.showCountryModal = true;
    }

    openMetatagModal() {
        this.showMetatagModal = true;
        this.$nextTick(() => {
            this.calcTextareaHeight();
        });
    }

    openDetailsModal(iccid: string) {
        this.eSimUid = iccid;
        this.showDetailsModal = true;
    }

    selectedCountryChanged(newSelectedCountry: Country) {
        this.selectedCountry = newSelectedCountry;
        this.countryValid = true;
    }

    incorrectCountry() {
        this.countryValid = false;
    }

    private calcTextareaHeight() {
        const textarea = this.$refs.metatag as HTMLTextAreaElement;
        if (!textarea) return;
        const lines = textarea.value.split(/\n/g) || [];
        const maxChars = this.isMobile ? 33 : 100;
        let numberOfLines = 0;
        lines.forEach((line: string) => {
            numberOfLines += Math.ceil(line.length / maxChars);
        });
        textarea.style.height = (this.isMobile ? numberOfLines * 16 + 70 : numberOfLines * 14 + 46) + "px";
    }

    private async performActivation() {
        try {
            this.isActivating = true;
            const result = await this.$store.dispatch("ACTIVATE_SOLD_ITEM", this.soldItem?.activatedItem.uid);
            console.log("Result:", result);
            this.showActivateModal = false;
            this.$toastr.success(this.$t("yourStore.history.details.activateSuccess"));
        } catch (error) {
            console.error("[Refund] Failed to activate item:", error);
            this.$toastr.error(this.$t("yourStore.history.details.activateError"));
        } finally {
            this.isActivating = false;
            this.reload();
        }
    }

    private async performRefund() {
        try {
            this.isRefunding = true;
            const result = await this.$store.dispatch("REFUND_SOLD_ITEM", this.soldItem?.activatedItem.uid);
            console.log("Result:", result);
            this.showRefundModal = false;
            this.$toastr.success(this.$t("yourStore.history.details.refundSuccess"));
        } catch (error) {
            console.error("[Refund] Failed to refund item:", error);
            this.$toastr.error(this.$t("yourStore.history.details.refundError", { message: error.message }));
        } finally {
            this.isRefunding = false;
            this.reload();
        }
    }

    private async updateCountryOfResidence() {
        if (!this.countryValid) return;
        try {
            this.isSavingCountry = true;
            const payload = {
                customerUid: this.soldItem?.customer.uid,
                countryOfResidence: this.selectedCountry?.code
            };
            console.log("The payload: ", payload);
            const response = await this.$store.dispatch("UPDATE_CUSTOMER", payload);
            console.log(response);
            this.showCountryModal = false;
            this.$toastr.success(this.$t("yourStore.history.details.setCountrySuccess"));
        } catch (error) {
            console.error("[Refund] Failed to refund item:", error);
            this.$toastr.error(this.$t("yourStore.history.details.setCountryError"));
        } finally {
            this.isSavingCountry = false;
            this.reload();
        }
    }

    private isExpired(date: string | null): boolean {
        if (!date) return false;
        const currentDate = new Date();
        const expiresAt = new Date(date);
        return currentDate > expiresAt;
    }

    private formatActivatedAt(date: string | null): string {
        return date
            ? this.$options.filters?.dateFormat(date)
            : this.$t("general.pending") as string;
    }

    private getVolume(item: any): string {
        return tools.getBalanceVolume(item.balance);
    }

    private getAddonsTotal(item: ActivatedItem): Price {
        const price = {
            currencyCode: item.activatedItem.purchasePrice.currencyCode,
            priceValue: 0,
            sortIndex: 0
        };
        return item?.addons.reduce((total: Price, addon: ActivatedItemAddon) => {
            return {
                currencyCode: total.currencyCode,
                priceValue: total.priceValue + addon.price.priceValue,
                sortIndex: total.sortIndex
            };
        }, price) ?? price;
    }

    private getRemaining(balance: Balance): string {
        const type = balance?.extendedDataPolicy?.type;
        if (type === "unlimited") return this.$t("general.unlimited") as string;
        return `${balance.availableBalance.sizeValue} ${balance.availableBalance.sizeUnit}`;
    }

    private getThrottledSpeed(balance: Balance): string {
        const throttleSpeed = balance.extendedDataPolicy?.throttleSpeed;
        return throttleSpeed ? throttleSpeed : "NA";
    }

    private getDailyHighSpeed(balance: Balance): string {
        const highSpeedVolume = balance.extendedDataPolicy?.totalHighSpeedVolume;
        return highSpeedVolume ? `${highSpeedVolume.sizeValue} ${highSpeedVolume.sizeUnit}` : "NA";
    }

    private getDailyBalance(balance: Balance): string {
        const remainingVolume = balance.extendedDataPolicy?.remainingHighSpeedVolume;
        return remainingVolume ? `${remainingVolume.sizeValue} ${remainingVolume.sizeUnit}` : "NA";
    }


    private getResetsAt(balance: Balance): string {
        const nextResetTime = balance.extendedDataPolicy?.nextResetTime;
        return nextResetTime ? this.$options.filters?.dateFormat(nextResetTime) as string : "NA";
    }
}
